exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.PatientConsentForMedicalRecordsExchange--3jdVX1swiD7tG5kDoBKGOQ {\n  background: linear-gradient(90deg, #a8aaa7, #b4b4af);\n  text-shadow: 0 -1px 0 #999;\n  border-radius: 4px;\n  text-transform: uppercase;\n  color: #fff;\n  font-weight: bold;\n  padding: 7px 15px;\n}\n", ""]);

// exports
exports.locals = {
	"cancelButton": "PatientConsentForMedicalRecordsExchange--3jdVX1swiD7tG5kDoBKGOQ",
	"cancelButton": "PatientConsentForMedicalRecordsExchange--3jdVX1swiD7tG5kDoBKGOQ"
};